import { SfLog } from '@app/adapters/logger'
import type { Tooltip } from '@app/setup/tooltip/uikit-tooltip'
import type { DrawerPosition, DrawerState } from '@app/shared/types/drawer'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tooltipElement']

  declare readonly tooltipElementTargets: HTMLElement[]

  connect(): void {
    window.eventHub.$on('drawer:open', this.handleDrawerOpen)
    window.eventHub.$on('drawer:close', this.handleDrawerClose)
  }

  disconnect(): void {
    window.eventHub.$off('drawer:open', this.handleDrawerOpen)
    window.eventHub.$off('drawer:close', this.handleDrawerClose)
  }

  private handleDrawerOpen = (drawer: DrawerState): void => {
    if (drawer.direction !== 'left') {
      return
    }
    this.disableTooltips()
  }

  private handleDrawerClose = (direction?: DrawerPosition): void => {
    if (direction !== 'left') {
      return
    }
    this.enableTooltips()
  }

  private enableTooltips(): void {
    this.tooltipElementTargets.forEach((element) => {
      const $tooltip = $(element)
      const tooltip = $tooltip.data('tooltip-instance') as Tooltip

      if (tooltip) {
        return
      }

      element.setAttribute('data-toggle', 'tooltip')
      $tooltip.trigger('tooltipsRendered')
    })
  }

  private disableTooltips(): void {
    this.tooltipElementTargets.forEach((element) => {
      const $tooltip = $(element)
      const tooltip = $tooltip.data('tooltip-instance') as Tooltip

      if (!tooltip) {
        return
      }

      try {
        tooltip.dispose()
      } catch (error) {
        SfLog.error('Error disposing tooltip', { error })
      }

      $tooltip.removeData('tooltip-instance')
      element.removeAttribute('data-toggle')
    })
  }
}
